module.exports = __webpack_public_path__ + "img/NL5011068.8860cd02.png";